<template>
  <b-container fluid>
    <h3 class="mb-4">پروفایل</h3>
    <profile-component
        :submit="updateProfile"
        :user="profile"
        @userUpdate="loadProfile"
        :changeRole="false"
    />
  </b-container>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import ProfileComponent from "../../../components/dashboard/Profile.vue";

export default {
  name: "profile",
  components: {ProfileComponent},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      profile: "User/getProfile",
    }),
  },
  methods: {
    updateProfile(data) {
      this.$store.dispatch("User/editProfile", data);
    },
    loadProfile() {
      this.$store.dispatch("User/getPerson", this.$store.getters['User/getUserId']);
    }
  },
  mounted() {
  },
};
</script>
<style scoped>
h3 {
  color: #bf61ea;
}
</style>
